import {
  ADD_POINT_SYSTEM_ERROR,
  ADD_POINT_SYSTEM_LOADING,
  ADD_POINT_SYSTEM_SUCCESS,
  UPDATE_PLAYER_STATUS_ERROR,
  UPDATE_PLAYER_STATUS_LOADING,
  UPDATE_PLAYER_STATUS_SUCCESS,
} from "../../../constant/actionTypes";

const updatePlayerStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PLAYER_STATUS_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case UPDATE_PLAYER_STATUS_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case UPDATE_PLAYER_STATUS_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default updatePlayerStatusReducer;
